import { DefaultResponse } from '@/shared/types/response.types'
import HttpService from '../HttpService'
import { formDataGenerator } from '../../api.utils'
import { retryCount } from '@/shared/constants/api.constants'
import { BackendVisitorType } from '@/shared/types/store.types'
import { AxiosResponse } from 'axios'

export class TravellerService extends HttpService {
  saveTraveller(data: object): Promise<DefaultResponse> {
    return this.post('savetraveller', formDataGenerator(data), {
      retry: retryCount,
      retryMessageIgnoreList: ['Invalid email address'],
    })
  }

  async getTravellers(): Promise<BackendVisitorType[]> {
    const { data } = await this.get<AxiosResponse>('gettravellers', { retry: retryCount })
    return data.list
  }

  removeTraveller(data: object): Promise<AxiosResponse> {
    return this.post('removetraveller', formDataGenerator(data))
  }

  removeTravellers(srNos: number[]): Promise<DefaultResponse> {
    return this.post(`removetravellers?srNos=${srNos.join(',')}`)
  }

  removeInsuredTravellers(): Promise<DefaultResponse> {
    return this.post('removetravellers?removeInsured=1')
  }

  async getPreapprovalVisa(passportNo: string, nationalityCode: string) {
    const { data } = await this.post<AxiosResponse>(
      `visadata?passportNo=${passportNo}&nationalityCode=${nationalityCode}`
    )
    return data.data
  }

  async inboundAddonCheck(civilId: string, startDate: string, endDate: string) {
    const { data } = await this.get<AxiosResponse>('inboundcheck', {
      params: { civilId, startDate, endDate },
    })
    return data
  }
}
